import React, { useEffect, useState } from "react";
import DataTableComponent from "../../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import ExportCSV from "../../../../components/ExportCsv/ExportCsv";
import { useGetDistributorWisePointInfoMutation } from "../../../../features/supplyBeam/inventory/checkoutListApi";

const DistributorWisePointInfo = () => {
  const navigate = useNavigate();
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const initialRequest = {
    mobile: "",
    limit: 10,
    offset: 0,
  };
  const [request, setRequest] = useState(initialRequest);
  const clearFilters = () => {
    setRequest(initialRequest);
  };

  // useEffect(() => {
  //   getList();
  // }, [request]);

  useEffect(() => {
    getList();
  }, []);

  const getListCsv = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    getListCsvApi({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
    });
  };

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  const [
    getListApi,
    {
      data: getListData,
      isLoading: getListIsLoading,
      isError: getListIsError,
      error: getListError,
    },
  ] = useGetDistributorWisePointInfoMutation();

  const [
    getListCsvApi,
    {
      data: getListCsvData,
      isLoading: getListCsvIsLoading,
      isError: getListCsvIsError,
      error: getListCsvError,
    },
  ] = useGetDistributorWisePointInfoMutation();

  const getList = () => {
    getListApi({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const columns = [
    {
      name: "SNo",
      selector: (row, idx) => idx + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "160px",
    },
    {
      name: "Mobile",
      selector: (row) => row.out_code,
      sortable: true,
      width: "100px",
    },
    {
      name: "Total Box",
      selector: (row) => row.total_count,
      sortable: true,
      width: "100px",
    },
    {
      name: "Total Points",
      selector: (row) => row.total_points,
      sortable: true,
      width: "200px",
    },
    {
      name: "Scan Count",
      selector: (row) => row.scan_count,
      sortable: true,
      width: "100px",
    },
    {
      name: "Scan Points",
      selector: (row) => row.scan_points,
      sortable: true,
      width: "200px",
    },
    {
      name: "Unscan Count",
      selector: (row) => row.unscan_count,
      sortable: true,
      width: "100px",
    },
    {
      name: "Unscan Points",
      selector: (row) => row.unscan_points,
      sortable: true,
      width: "200px",
    },
  ];

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Distributor Point Inventory
            <LinksComponent />
          </div>

          <div className=" p-3">
            {getListCsvData &&
              getListCsvData?.body?.data && (
                <ExportCSV
                  data={ getListCsvData?.body?.data }
                  columnsToExport={[
                    "name",
                    "employee_id",
                    "email",
                    "mobile",
                    "designation",
                    "role_name",
                  ]}
                />
              )}
            <div className=" bg-white shadow rounded-lg">
              <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex  space-x-2 justify-between">
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Name
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Name..."
                        required
                        value={request.name}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, name: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Mobile No..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex flex-row gap-2 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary pdbtn_all clear-both float-right "
                        onClick={() => {
                            getList();
                            // getAllUsersCsvFunction();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary pdbtn_all clear-both float-right whitespace-nowrap"
                        onClick={() => {
                          clearFilters();
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <DataTableComponent
              keyField={(row) => row.SNo}
                columns={columns}
                data={getListData && getListData.body.data}
                loading={getListIsLoading}
                totalRows={
                  getListData && getListData.body.total_count
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
              <div
                className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                id="box_btn"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DistributorWisePointInfo;
